import {Act} from './Act';

/**
 * Use SequenceAct as container for a chain of Acts.
 * It is await like behaviour.
 */
export class SequenceAct extends Act {
    private activeAct?: Act;
    private _children: Act[] = [];
    public async skip(): Promise<void> {
        this._isSkipped = true;

        if (this.activeAct) {
            return this.activeAct.skip();
        } else {
            return;
        }
    }

    public async forceSkip(): Promise<void> {
        for (const act of this._children) {
            await act.forceSkip();
            act.dispose();
        }
    }

    protected async executeInternal(): Promise<void> {
        for (const act of this._children) {
            if (this._isSkipped) {
                await act.forceSkip();
                act.dispose();
            } else if (this.executeSkipOnRoot) {
                this.activeAct = act;
                act.executeSkipOnRoot = this.executeSkipOnRoot;
                await new Promise(res => act.execute(() => res(undefined)));
                act.dispose();
            }
        }
    }

    public removeAllEventListeners(): void {
        super.removeAllEventListeners();

        this._children.forEach(child => {
            child.removeAllEventListeners();
        });
    }

    public set isSkipped(value: boolean) {
        this._isSkipped = value;
        this._children.forEach(act => {
            act.isSkipped = value;
        });
    }

    public set children(value: Act[]) {
        this._children = value;
    }

    public dispose(): void {
        super.dispose();
        this._children.forEach(act => {
            act.dispose();
        });
        this.activeAct = undefined;
    }

}